module.exports = __webpack_public_path__ + "static/media/wedding5.0db8013a.jpg";